module.exports = __webpack_public_path__ + "img/home-report.dcf36c4a.svg";